'use client';

import React from 'react';

import { smartTruncate } from '@/shared/text';

export default function HeroDescription({
  description = '',
  enableExpandDescription = true,
  className = '',
  mobileLimit,
}) {
  const [isMounted, setIsMounted] = React.useState(false);
  const [textLimit, setTextLimit] = React.useState(400);
  const [expanded, setExpanded] = React.useState(false);
  const { short, isTruncated } = React.useMemo(
    () => smartTruncate(description, textLimit),
    [description, textLimit]
  );

  // Mobile detection when responsive limits are provided
  React.useEffect(() => {
    setIsMounted(true);

    if (!mobileLimit) return;

    const checkMobile = () => {
      if (window.innerWidth < 1024) {
        setTextLimit(mobileLimit);
      } else {
        setTextLimit(400);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, [mobileLimit]);

  return (
    <>
      <div
        id="event-desc"
        className={`text-[#626262] font-outfit lg:text-lg text-base font-normal leading-[1.55em] ${className}`}
      >
        <div
          className="inline ck-content [&_a]:underline [&_a:hover]:no-underline [&_p]:inline"
          dangerouslySetInnerHTML={{
            __html:
              enableExpandDescription && (expanded || !isTruncated)
                ? description
                : enableExpandDescription && isMounted
                  ? `${short}…`
                  : description,
          }}
        />
        {enableExpandDescription && isTruncated && isMounted && (
          <button
            type="button"
            aria-expanded={expanded}
            aria-controls="event-desc"
            aria-label={
              expanded ? 'Collapse to hide additional content' : 'Expand to read more content'
            }
            onClick={() => setExpanded((v) => !v)}
            className="inline underline lg:text-lg text-base focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-sky-600"
          >
            {expanded ? 'less' : 'more'}
          </button>
        )}
      </div>
    </>
  );
}
